export default "__VITE_ASSET__CDLG4UpJ__"